import { Component, OnInit } from '@angular/core';
import {ShopService} from '@modules/shop/services/shop.service';
import {ShopSectionLayout} from '@lib-modules/section/components/shop-section/shop-section.component';

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss']
})
export class ShopComponent implements OnInit {

  public shopLayout = ShopSectionLayout.Grid

  constructor (
    public shopService: ShopService,
  ) {}

  public async ngOnInit(): Promise<void> {
    await this.shopService.init()
  }
}
